<template>
  <div>
    <div class="identite-coureur  my-4 mx-2">
      <v-skeleton-loader v-if="!loaded" class="mx-auto" type="image" min-height="600"></v-skeleton-loader>
      <template v-else>
        <!-- Si ce n'est pas une inscription admin -->
        <div
          v-if="(!mainStore.inscription_as_admin && !initial_commande_inscription) || mainStore.authAdmin.hasSuperAdminRights">
          <!-- Si l'utilisateur est connecté, on affiche ses coureurs -->
          <SelectCoureurFromAccount v-if="mainStore.authUser.isLogged" :coureur="coureur" @onClearCoureur="clearCoureur"
            @onSelectCoureur="importCoureur">
          </SelectCoureurFromAccount>
          <!-- Si l'utilisateur n'est pas connecté, on lui propose de se connecter ou de s'inscrire -->
          <SuggestLogin v-else></SuggestLogin>
        </div>

        <p class="mt-3" v-if="mainStore.is_default_mode">Les informations suivantes
          sont nécessaires pour l'inscription au(x) parcours sélectionné(s):</p>
        <p class="mt-3" v-else>Les informations suivantes sont nécessaires pour effectuer une commande:</p>
        <!-- Formulaire des infos coureurs  -->
        <v-form ref="formCoureur" v-model="valid" class="mb-5">
          <v-row>
            <v-col :md="get_nb_cols(champ)" cols="12" class="py-0"
              v-for="(champ, index_champ) in coureur_champs_met_condition" :key="index_champ">
              <div>
                <!-- Si c'est le select de sélection de document -->
                <div v-if="champ.nom == 'type_document'">
                  <Champ_Select_Document :champ="champ" :inscription="inscription" :is_disable="is_disable(champ)"
                    @validate_mineur="on_validate_mineur_document" @validate_moins_12="on_validate_mineur_document">
                  </Champ_Select_Document>
                </div>
                <div v-else-if="champ.nom == 'type_inscription_ffr'">
                  <Champ_Select_Inscription_FFR :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)">
                  </Champ_Select_Inscription_FFR>
                </div>
                <!-- Si c'est le champs ville -->
                <div v-else-if="champ.nom == 'ville'">
                  <!-- Si on détecte une commune francaise associé au code postal, on propose une sélection -->
                  <Champ_Select_Ville v-if="is_commune_francaise" :champ="champ" :cp="coureur.champs.cp.value"
                    :inscription="inscription" :is_disable="is_disable(champ)"></Champ_Select_Ville>
                  <!-- Sinon texte libre -->
                  <Champ_Text v-else :champ="champ" :inscription="inscription" :is_disable="is_disable(champ)">
                  </Champ_Text>
                </div>
                <!-- Si c'est le champs de numéro de licence -->
                <div v-else-if="champ.nom == 'licence'">
                  <Champ_Licence :champ="champ" :inscription="inscription" :is_disable="is_disable(champ)">
                  </Champ_Licence>
                </div>
                <div v-else-if="champ.nom == 'numero_pps'">
                  <Champ_PPS :champ="champ" :inscription="inscription" :is_disable="is_disable(champ)"></Champ_PPS>
                </div>
                <div v-else-if="champ.nom == 'numero_licence_ffr' || champ.nom == 'numero_licence_ffr_competition'">
                  <Champ_Licence_FFR :champ="champ" :inscription="inscription" :is_disable="is_disable(champ)">
                  </Champ_Licence_FFR>

                </div>
                <div v-else-if="champ.nom == 'cote_betrail_indicatif'">
                  <Champ_Cote_Betrail_Indicatif :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)">
                  </Champ_Cote_Betrail_Indicatif>

                </div>

                <div v-else-if="champ.nom == 'date_naissance'">
                  <Champ_Date_Naissance :champ="champ" :inscription="inscription"
                    @change_identity_coureur="change_identity_coureur" :is_disable="is_disable(champ)">
                  </Champ_Date_Naissance>
                </div>
                <!-- Les autres champs sans traitement particulier -->
                <div v-else>
                  <Champ_Telephone v-if="champ.type == 'tel'" :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)"></Champ_Telephone>

                  <Champ_HTML v-if="champ.type == 'html'" :champ="champ"
                    :is_changement_parcours="initial_commande_inscription" :is_disable="is_disable(champ)"></Champ_HTML>
                  <Champ_Text v-if="champ.type == 'text'" :champ="champ" :inscription="inscription"
                    @change_identity_coureur="change_identity_coureur" :is_disable="is_disable(champ)"></Champ_Text>
                  <Champ_Autocomplete v-if="champ.type == 'autocomplete'" :champ="champ" :inscription="inscription"
                    @change_identity_coureur="change_identity_coureur" :is_disable="is_disable(champ)">
                  </Champ_Autocomplete>
                  <Champ_Select v-if="champ.type == 'select'" :champ="champ" :inscription="inscription"
                    @change_identity_coureur="change_identity_coureur" :is_disable="is_disable(champ)"></Champ_Select>
                  <Champ_Select_Multiple v-if="champ.type == 'select_multiple'" :champ="champ"
                    :inscription="inscription" :is_disable="is_disable(champ)"></Champ_Select_Multiple>
                  <Champ_Date v-if="champ.type == 'date'" :champ="champ" :inscription="inscription"
                    @change_identity_coureur="change_identity_coureur" :is_disable="is_disable(champ)"></Champ_Date>
                  <Champ_Number v-if="champ.type == 'number'" :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)"></Champ_Number>
                  <Champ_Boolean v-if="champ.type == 'boolean'" :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)"></Champ_Boolean>
                  <Champ_Document v-if="champ.type == 'document'" :champ="champ" :inscription="inscription"
                    :is_disable="is_disable(champ)"></Champ_Document>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <!-- Affichage des erreurs relatives au formulaire -->
        <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors" :key="index_error"
          type="error">
          {{ error }}
        </v-alert>

        <div v-if="show_autorisation_parentale" class="bordered bg-grey_1 px-2 py-1 mb-3 d-flex align-start">
          <v-checkbox-btn class="checkbox_autorisation_aprentale mb-1" color="primary-dark" hide-details
            v-model="check_autorisation_parentale"></v-checkbox-btn>
          <div class="mt-2" v-html="content_autorisation_parentale"></div>
        </div>

        <v-alert v-if="only_validated_can_register" class="mb-2">
          {{ content_only_validated_can_register }}
        </v-alert>
      </template>
    </div>
    <NavigationStepButtons :canContinue="can_continue" :canGoBack="canGoBack" @goToNextStep="validate"
      @goToPreviousStep="$emit('goToPreviousStep')" class="bg-spo-light" />
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { useChampsFormulaireStore } from "@/stores/champsFormulaireStore";
import { mapStores } from "pinia";
import Champ_Text from "@/components/Inscription/Champs_Formulaire/Champ_Text.vue";
import Champ_Date from "@/components/Inscription/Champs_Formulaire/Champ_Date.vue";
import Champ_Date_Naissance from "./Champs_Formulaire/Champ_Date_Naissance.vue";
import Champ_HTML from "@/components/Inscription/Champs_Formulaire/Champ_HTML.vue";
import Champ_Number from "@/components/Inscription/Champs_Formulaire/Champ_Number.vue";
import Champ_Select from "@/components/Inscription/Champs_Formulaire/Champ_Select.vue";
import Champ_Select_Document from "@/components/Inscription/Champs_Formulaire/Champ_Select_Document.vue";
import Champ_Boolean from "@/components/Inscription/Champs_Formulaire/Champ_Boolean.vue";
import Champ_Document from "@/components/Inscription/Champs_Formulaire/Champ_Document.vue";
import Champ_Select_Ville from "@/components/Inscription/Champs_Formulaire/Champ_Select_Ville.vue";
import Champ_Licence from "@/components/Inscription/Champs_Formulaire/Champ_Licence.vue";
import Champ_PPS from "@/components/Inscription/Champs_Formulaire/Champ_PPS.vue";
import Champ_Licence_FFR from "@/components/Inscription/Champs_Formulaire/Champ_Licence_FFR.vue";
import Champ_Cote_Betrail_Indicatif from "@/components/Inscription/Champs_Formulaire/Champ_Cote_Betrail_Indicatif.vue";
import Champ_Select_Inscription_FFR from "@/components/Inscription/Champs_Formulaire/Champ_Select_Inscription_FFR.vue";
import Champ_Select_Multiple from "@/components/Inscription/Champs_Formulaire/Champ_Select_Multiple.vue";
import Champ_Telephone from "@/components/Inscription/Champs_Formulaire/Champ_Telephone.vue";
import Champ_Autocomplete from "@/components/Inscription/Champs_Formulaire/Champ_Autocomplete.vue";
import SuggestLogin from "@/components/Inscription/SuggestLogin.vue";
import SelectCoureurFromAccount from "./IdentiteCoureur/SelectCoureurFromAccount.vue";
import NavigationStepButtons from "./InscriptionItem/NavigationStepButtons.vue";
export default {
  props: {
    item: { type: Object, required: true },
    initial_commande_inscription: { type: Object, default: null },
    canGoBack: { type: Boolean, default: true },
  },
  components: { Champ_Text, Champ_Date, Champ_Number, Champ_HTML, Champ_Select, Champ_Boolean, Champ_Document, Champ_Select_Ville, Champ_Licence, SuggestLogin, Champ_Select_Document, Champ_PPS, Champ_Licence_FFR, Champ_Date_Naissance, SelectCoureurFromAccount, Champ_Select_Inscription_FFR, Champ_Select_Multiple, Champ_Telephone, Champ_Autocomplete, Champ_Cote_Betrail_Indicatif, NavigationStepButtons },
  data() {
    return {
      loaded: false,
      errors: [],
      valid: true,
      inscription: null,
      coureur: null,
      check_autorisation_parentale: false,
    };
  },

  computed: {
    ...mapStores(useMainStore, useChampsFormulaireStore),
    is_mineur() {
      if (!this.inscription || !this.inscription.coureur) return false;
      return this.inscription.coureur.is_mineur();
    },
    coureur_champs_met_condition() {
      return this.coureur.get_list_champs_meet_conditions(this.inscription.list_courses);
    },
    is_commune_francaise() {
      return this.coureur.is_commune_francaise();
    },
    show_autorisation_parentale() {
      const demande_autorisation_parentale = this.mainStore.module.demande_autorisation_parentale;
      return this.is_mineur && demande_autorisation_parentale;
    },
    content_autorisation_parentale() {
      const text_autorisation_parentale = this.mainStore.module.texte_autorisation_parentale;
      if (text_autorisation_parentale) return text_autorisation_parentale;
      return "<p>Inscription mineur: en cliquant sur continuer, je confirme que le mineur a l'autorisation de son représentant légal pour s'inscrire à cet évènement.</p>";
    },
    only_validated_can_register() {
      const only_validated_can_register = this.mainStore.module.only_validated_can_register;
      if (!only_validated_can_register) return false;
      if (!this.inscription || !this.inscription.coureur || !this.inscription.coureur.champs || !this.inscription.coureur.champs.type_document) {
        return false;
      }
      let type_document = this.inscription.coureur.champs.type_document.value;
      let coureur_valide = this.inscription.coureur.document_valide;

      if (type_document == "Sélectionnez le type de document") {
        return true;
      }

      if ((type_document == "Licence FFA" || type_document == "Pass Prévention Santé") && coureur_valide != '1') {
        return true;
      }
      return false;
    },
    content_only_validated_can_register() {
      if (!this.inscription || !this.inscription.coureur || !this.inscription.coureur.champs || !this.inscription.coureur.champs.type_document) {
        return "";
      }
      let type_document = this.inscription.coureur.champs.type_document.value;
      let coureur_valide = this.inscription.coureur.document_valide;

      if (type_document == "Sélectionnez le type de document") {
        return "Vous devez sélectionner un type de document pour continuer.";
      }
      if (type_document == "Licence FFA" && coureur_valide != '1') {
        return "Nous n'avons pas pu valider la licence de ce coureur via le webservice FFA. Veuillez vérifier les informations saisies.";
      }

      if (type_document == "Pass Prévention Santé" && coureur_valide != '1') {
        return "Nous n'avons pas pu valider le Pass Prévention Santé de ce coureur. Veuillez vérifier les informations saisies.";
      }
      return "";
    },
    can_continue() {
      if (this.show_autorisation_parentale && !this.check_autorisation_parentale) {
        return false;
      }
      if (this.only_validated_can_register) {
        return false;
      }
      return true;
    },
  },
  methods: {
    clearCoureur() {
      this.coureur.clear();
    },
    on_validate_mineur_document() {
      this.inscription.coureur.validate_document();
    },
    importCoureur(data) {
      this.coureur.set(data, false, true);
    },
    is_disable(champ) {
      return champ.is_disabled(this.initial_commande_inscription);
    },
    get_nb_cols(champ) {
      if (champ.type == "html" || champ.nom == "cote_betrail_indicatif") {
        return 12;
      }
      return 6;
    },

    /**
     * Asynchronously verifies any incoherence in the data.
     * This method performs checks to ensure data consistency and correctness.
     * 
     * @returns {Promise<void>} A promise that resolves when the verification is complete.
     */
    async verify_incoherence() {
      const check_incoherence = await this.coureur.checkIncoherence();
      if (check_incoherence) {
        this.$emit("onIncoherence", check_incoherence);
      }

    },

    /**
     * This method is responsible for handling changes to the identity of the runner.
     * It performs necessary updates and validations when the runner's identity information is modified.
     */
    change_identity_coureur() {
      this.coureur.id = null;
    },

    /**
     * Validates the form data for the IdentiteCoureur component.
     * This method performs asynchronous validation checks to ensure
     * that all required fields are correctly filled out and meet the
     * specified criteria.
     *
     * @returns {Promise<void>} A promise that resolves when the validation
     * process is complete.
     */
    async validate() {
      this.errors = [];

      if (this.show_autorisation_parentale && !this.check_autorisation_parentale) {
        this.errors.push("Vous devez confirmer l'autorisation parentale pour ce participant mineur.");
        return;
      }

      if (this.only_validated_can_register) {
        this.errors.push(this.content_only_validated_can_register);
        return;
      }

      let res = await this.$refs.formCoureur.validate();
      if (res.valid || this.mainStore.inscription_as_admin) {
        if (!this.mainStore.inscription_as_admin) {
          await this.verify_incoherence();
        }
        this.$emit("goToNextStep");
      } else {
        this.errors.push("Certains champs nécessitent votre attention, merci de les vérifier avant de continuer.");
      }

    },


  },
  async mounted() {
    this.loaded = false;
    this.inscription = this.item;
    this.inscription.set_finished(false);
    this.coureur = this.inscription.coureur;
    if (this.mainStore.authUser.isLogged) {
      this.coureur.id_utilisateur = this.mainStore.authUser.userData.id;
    }

    if (!this.mainStore.champs_formulaire.isLoaded) {
      await this.mainStore.champs_formulaire.fetch();
    }
    this.inscription.initialize_champs_coureur(this.champsFormulaireStore.$state, this.mainStore.billetterie_mode, this.mainStore.module.hide_sexe_birthdate_fields);
    if (this.inscription.duplicate_from) {
      this.inscription.applyDuplicateFromSource(
        this.champsFormulaireStore.$state,
        this.mainStore.billetterie_mode,
        this.mainStore.module.hide_sexe_birthdate_fields
      );
      this.coureur.nom_coureur = this.coureur.get_nom();
    }
    // Si changement de parcours, récupere les infos depuis la commande initiale
    if (this.initial_commande_inscription) {
      this.coureur.set_from_initial_commande_inscription(this.initial_commande_inscription);
    }
    if (this.mainStore.bookingSystem.groupe.default_fields) {
      this.coureur.set_group_default_fields(this.mainStore.bookingSystem.groupe.default_fields);
    }
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
v-checkbox p {
  margin-bottom: 0 !important;
}
</style>